$(document).ready(function () {

    if ($(".saso-cart-original-total").length) {
        var checkExist = setInterval(function () {
            var selector = [".toast-message"];
            $.each(selector, function (key, val) {
                if ($(val).length) {
                    isIframeReady();
                    clearInterval(checkExist);
                    console.log('hit');
                   }
            });
        }, 10);

        isIframeReady = function () {

            $('.toast-message').contents().clone().appendTo('.discount-text');
            $('.discount-text').show().css('background-color', '#0597c4');
            $('.hulkapps-cart-original-total').css('color', 'red');
            $('.hulkapps-cart-original-total').css('font-style', 'italic');
            $('#toast-container').remove();
            return false;
        }
    }

});